import { Component, inject, OnInit } from '@angular/core';
import { AdminBoilerplateComponent } from '../../../core/admin-boilerplate/feature/admin-boilerplate.component';
import { Store } from '@ngrx/store';
import { AdminService } from '../../../data-services/admin.service';
import { selectAdminAllEvents, selectAdminArchiveEvents } from '../../../data-services/stores/selectors/admin.selectors';
import { adminActions } from '../../../data-services/stores/actions/admin.actions';
import { AsyncPipe } from '@angular/common';
import { AdminEventSummaryComponent } from '../../events/summary/feature/summary.component';
import { ActivatedRoute } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { EventComplete } from '../../../data-services/models/events/event-complete.model';

@Component({
  selector: 'app-admin-dashboard',
  imports: [AdminBoilerplateComponent, AsyncPipe, AdminEventSummaryComponent],
  templateUrl: '../ui/dashboard.component.html',
  styleUrl: '../ui/dashboard.component.css'
})
export class AdminDashboardComponent implements OnInit {
  private readonly _store = inject(Store);
  private readonly _route = inject(ActivatedRoute);
  archive: boolean = this._route.snapshot.data["archive"] || false;

  eventList$?: Observable<EventComplete[]>


  ngOnInit(): void {
    if (this.archive) {
      this._store.dispatch(adminActions.getArchivedEvents())
      this.eventList$ = this._store.select(selectAdminArchiveEvents).pipe(tap(x => console.log('archive',x)))
    }
    else {
      this._store.dispatch(adminActions.getAllEvents()) 
      this.eventList$ = this._store.select(selectAdminAllEvents)
    }
  }
}
